export default __webpack_public_path__ + "static/media/hair-bright-spring.d1ff08b7.png";